module.exports = __webpack_public_path__ + "img/student-portal-logo.3a847e26.png";